import { themePalette } from '@theme/muiTheme';
import styled from 'styled-components';

export const LinksWrapper = styled('div')<{
  $disabled: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 434px;
  height: 40px;
  padding: 1px;
  border: 1px solid ${themePalette.grey[700]};
  border-radius: 12px;
  background-color: ${themePalette.grey[400]};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'all')};
`;
